import { createFileRoute, notFound } from '@tanstack/react-router';
import { useCallback } from 'react';
import { isReportKey } from '@hlt/domain';
import { parseAnalyticsSearch, type AnalyticsSearch } from '@/features/analytics/filter-search';
import { ReportPage } from '@/features/analytics/pages/report-page';

/** `/analytics/reports/:reportKey`: a predefined, meeting-ready page. */
export const Route = createFileRoute('/_app/w/$workspaceId/analytics/reports/$reportKey')({
    staticData: {
        crumbs: [{ label: 'shell.analytics', to: '/w/$workspaceId/analytics' }, { label: 'shell.crumbPage' }],
    },
    beforeLoad: ({ params }) => {
        if (!isReportKey(params.reportKey)) throw notFound();
    },
    validateSearch: (raw: Record<string, unknown>): AnalyticsSearch => parseAnalyticsSearch(raw),
    component: function AnalyticsReportRoute() {
        const { workspaceScope } = Route.useRouteContext();
        const { reportKey } = Route.useParams();
        const search = Route.useSearch();
        const navigate = Route.useNavigate();
        const onSearch = useCallback(
            (patch: Partial<AnalyticsSearch>) =>
                void navigate({
                    search: (prev) => parseAnalyticsSearch({ ...prev, ...patch }),
                    replace: true,
                }),
            [navigate],
        );
        if (!isReportKey(reportKey)) return null;
        return (
            <ReportPage
                key={reportKey}
                scope={workspaceScope}
                reportKey={reportKey}
                search={search}
                onSearch={onSearch}
            />
        );
    },
});
